import {cardTitle} from "assets/jss/material-dashboard-pro-react.jsx";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const gestaoStyle = {
  ...customCheckboxRadioSwitch,
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    "& small": {
      fontSize: "80%",
      fontWeight: "400"
    },
    textTransform: "capitalize"
  },
  cardCategory: {
    marginTop: "10px",
    color: "#999999 !important",
    textAlign: "center"
  },
  description: {
    color: "#999999"
  },
  updateProfileButton: {
    float: "right"
  },
  ContainerCaixas: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start"
  },
  gestaoContainer: {
    "&> div > div > h2": {
      padding: "0",
      margin: "0"
    },
  },
  addStuffButton: {
    padding: "5px 12px 5px 10px!important",
    //marginLeft: "10px!important"
  },
  ...buttonStyle,
  ...customSelectStyle,
  selectMenu: {
    zIndex: 9000
  },
  modalCardTitle: {
    fontSize: "20px",
    position: "relative",
    top: "5px",
    left: "10px"
  },
  exportar: {
    marginTop: "-3px",
    padding: "12px 8px"
  },
};

export default gestaoStyle;
